"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpportunityForJobView = void 0;
const typeorm_1 = require("typeorm/browser");
const opportunity_1 = require("../opportunity");
const opportunity_base_1 = require("../opportunity-base");
const opportunity_option_1 = require("../opportunity-option");
const job_status_enum_1 = require("../job-status-enum");
const currency_tax_configuration_for_job_view_1 = require("./currency-tax-configuration-for-job-view");
const entity_1 = require("../../util/entity");
const brand_3 = require("../brand");
const entity_2 = require("../../util/entity");
const contact_profile_enum_1 = require("../contact-profile-enum");
const user_role_enum_1 = require("../user-role-enum");
let OpportunityForJobView = class OpportunityForJobView extends opportunity_base_1.OpportunityBase {
};
__decorate([
    (0, typeorm_1.Column)({
        type: 'enum',
        enum: user_role_enum_1.UserRoleEnum,
        array: true,
        default: '{}',
    }),
    __metadata("design:type", Array)
], OpportunityForJobView.prototype, "canCreateProposal", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'enum',
        enum: user_role_enum_1.UserRoleEnum,
        array: true,
        nullable: true,
        default: '{}',
    }),
    __metadata("design:type", Array)
], OpportunityForJobView.prototype, "canApproveProposal", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'enum',
        enum: user_role_enum_1.UserRoleEnum,
        array: true,
        default: '{}',
    }),
    __metadata("design:type", Array)
], OpportunityForJobView.prototype, "canPreApproveProposal", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'enum',
        enum: contact_profile_enum_1.ContactProfileEnum,
        array: true,
        default: '{}',
        name: 'approval_contact_profiles',
    }),
    __metadata("design:type", Array)
], OpportunityForJobView.prototype, "approvalContactProfiles", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'enum',
        enum: job_status_enum_1.JobStatusEnum,
        nullable: true,
    }),
    __metadata("design:type", String)
], OpportunityForJobView.prototype, "customerApprovalTargetStatus", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => currency_tax_configuration_for_job_view_1.CurrencyTaxConfigurationForJobView, (currencyTax) => currencyTax.opportunities, {
        eager: true,
    }),
    __metadata("design:type", currency_tax_configuration_for_job_view_1.CurrencyTaxConfigurationForJobView)
], OpportunityForJobView.prototype, "currencyTaxConfig", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => brand_3.Brand, (brand) => brand.id, { nullable: true }),
    (0, typeorm_1.JoinColumn)({ name: 'injected_communication_account_sfid' }),
    __metadata("design:type", brand_3.Brand)
], OpportunityForJobView.prototype, "brand", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => brand_3.Brand, (brand) => brand.id, { nullable: true }),
    (0, typeorm_1.JoinColumn)({ name: 'brand_1' }),
    __metadata("design:type", brand_3.Brand)
], OpportunityForJobView.prototype, "brand_1", void 0);
__decorate([
    (0, typeorm_1.ManyToOne)(() => brand_3.Brand, (brand) => brand.id, { nullable: true }),
    (0, typeorm_1.JoinColumn)({ name: 'brand_2' }),
    __metadata("design:type", brand_3.Brand)
], OpportunityForJobView.prototype, "brand_2", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        default: 14,
        name: 'due_days',
    }),
    __metadata("design:type", Number)
], OpportunityForJobView.prototype, "dueDays", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        nullable: true,
        length: 255,
        name: 'purchase_order_number',
    }),
    __metadata("design:type", String)
], OpportunityForJobView.prototype, "purchaseOrderNumber", void 0);
__decorate([
    (0, typeorm_1.Column)({
        nullable: true,
    }),
    __metadata("design:type", String)
], OpportunityForJobView.prototype, "productOrderCondition", void 0);
OpportunityForJobView = __decorate([
    (0, typeorm_1.ViewEntity)({
        expression: (connection) => {
            const opportunityColumns = (0, entity_1.getEntityColumns)(opportunity_base_1.OpportunityBase, connection);
            const opportunityOptionsColumns = (0, entity_1.getEntityColumns)(opportunity_option_1.OpportunityOption, connection);
            let qb = connection
                .createQueryBuilder()
                .from(opportunity_1.Opportunity, 'opportunity')
                .leftJoin(opportunity_option_1.OpportunityOption, 'opportunity_options', '(opportunity_options.opportunity_sfid = opportunity.sfid)');
            const columnsIterator = new entity_1.EntityColumnIterator({
                opportunity_sfid: true,
            });
            columnsIterator.all(opportunityColumns, (columnName) => {
                qb.addSelect(`opportunity.${columnName}`, columnName);
            });
            columnsIterator.all(opportunityOptionsColumns, (columnName) => {
                qb.addSelect(`opportunity_options.${columnName}`, columnName);
            });
            const viewVersion = (0, entity_2.getViewVersion)(qb, [], connection);
            qb.comment(`-- DDL checksum : ${viewVersion.hash}`);
            return qb;
        },
    })
], OpportunityForJobView);
exports.OpportunityForJobView = OpportunityForJobView;
//# sourceMappingURL=opportunity-for-job-view.js.map